var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMissionsTranslation } from '../../ui/hooks';
import { visuallyHidden } from '@juvare/common-form-ui/utils/visualyHidden';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, IconButton } from '@mui/material';
import React from 'react';
const autoHideDuration = 3000;
export const CopyButton = ({ value, successMessage }) => {
    const { t } = useMissionsTranslation();
    const handleCopy = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.stopPropagation();
        try {
            yield navigator.clipboard.writeText(value);
            successMessage && showAlertSnackbar({ type: 'success', message: successMessage, autoHideDuration });
        }
        catch (error) {
            handleErrorSnackbar(error);
        }
    });
    const ariaLabelId = React.useId();
    return (React.createElement(IconButton, { onClick: handleCopy, "aria-labelledby": ariaLabelId },
        React.createElement(Box, { id: ariaLabelId, sx: visuallyHidden }, t('ariaLabels.copyToClipboard')),
        React.createElement(ContentCopyIcon, { htmlColor: themeColors.icon.link, sx: { fontSize: 18 } })));
};
